import React, { useEffect, useState } from 'react'
import axios from 'axios'
import AdminDashboard from './AdminDashboard'
import Swal from 'sweetalert2'

const Allfjobs = () => {


    const [localjobs, setLocaljobs] = useState([])

    const getAll = () => {
        axios.get('https://api.myskills.lk/fjobs/getall').then((response) => {
            setLocaljobs(response.data)
        }).catch((err) => {
            console.log(err)
        })
    }
    useEffect(() => {
        getAll();


    }, [])



    const [searchTerm, setSearchTerm] = useState('')

    const handleSearch = (e) => {
        e.preventDefault()
        setSearchTerm(e.target.value)
    }

    const filteredInstitutes = localjobs.filter((institute) =>
        institute.aname && institute.aname.toLowerCase().includes(searchTerm.toLowerCase())
    );


    const UpdateDelete = (e, id) => {
        e.preventDefault();
        console.log(id);

        Swal.fire({
            title: "Are you sure?",
            text: "Do you want to remove this foreign job?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085d6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes, remove it!"
        }).then((result) => {
            if (result.isConfirmed) {
                axios.post('https://api.myskills.lk/fjobs/updateapprove', { id: id, approve: 0 }).then((response) => {
                    getAll();
                    Swal.fire({
                        title: "Removed!",
                        text: "The foreign job has been removed from the approved list.",
                        icon: "success"
                    });
                }).catch((err) => {
                    console.log(err);
                    Swal.fire({
                        title: "Error!",
                        text: "Failed to remove the foreign job.",
                        icon: "error"
                    });
                });
            }
        });
    }

    console.log(localjobs);





    return (
        <div>

            <AdminDashboard />

            <div className='AllViews-admin'>

                <div className="search-icon-admin admin-institute-search">

                    <h1>ALL FOREIGN JOBS</h1>
                    <div>
                        <button id="del-details" style={{ width: "auto", marginBottom: "10px", padding: "8px", backgroundColor: "blue", color: "white" }} > <a href="/allfpjob" style={{ color: "white" }}>PENDING JOBS</a> </button>
                        <form >
                            <input type="text" onChange={handleSearch} id="" placeholder='Search Item' />
                            <input type="submit" value="SEARCH" />
                        </form>
                    </div>
                </div>

                <div className="scroller-box">
                    <div className="table-institute">
                        <table>
                            <thead>
                                <tr>
                                    <th>Agency Name</th>
                                    <th>Agency No</th>
                                    <th>End Date</th>
                                    <th>Email</th>
                                    <th>Contact</th>
                                    <th>Country</th>
                                    <th>View</th>
                                    <th>Action</th>

                                </tr>
                            </thead>

                            <tbody>


                                {filteredInstitutes.length > 0 ? (
                                    filteredInstitutes.map((insti) => (
                                        <tr key={insti.id}>
                                            <td>{insti.aname}</td>
                                            <td>{insti.ano}</td>
                                            <td>{insti.cdate}</td>
                                            <td>{insti.email}</td>
                                            <td>{insti.contact}</td>
                                            <td>{insti.country}</td>
                                            <td>
                                                <button id="view-web">
                                                    <a href={`/fjob/${insti.id}`}>SITE VIEW</a>
                                                </button>
                                            </td>
                                            <td id="action-buttons">
                                                <button
                                                    onClick={(e) => {
                                                        UpdateDelete(e, insti.id)
                                                    }}
                                                    id="app-details" style={{ backgroundColor: "red" }}
                                                >
                                                    REMOVE
                                                </button>
                                            </td>

                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan="8" style={{ textAlign: 'center', padding: '10px' }}>
                                            Search data not found
                                        </td>
                                    </tr>
                                )}





                            </tbody>
                        </table>

                    </div>

                </div>

            </div>



        </div>

    )
}

export default Allfjobs